import { render, staticRenderFns } from "./ImsChannel.vue?vue&type=template&id=ace7a9e8&scoped=true"
import script from "./ImsChannel.vue?vue&type=script&lang=js"
export * from "./ImsChannel.vue?vue&type=script&lang=js"
import style0 from "./ImsChannel.vue?vue&type=style&index=0&id=ace7a9e8&prod&lang=css"
import style1 from "./ImsChannel.vue?vue&type=style&index=1&id=ace7a9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace7a9e8",
  null
  
)

export default component.exports